import React from 'react';
import { COMMIT_BACKEND, COMMIT_FRONTEND } from '../constant';
import { CommitIcon } from '../appearence/icons/commit_icon';
import { Tooltip } from './Tooltip';

const shortSha = (sha) => sha.trim().slice(0, 8);

const CommitInfo = () => {
    if (!COMMIT_BACKEND.trim() && !COMMIT_FRONTEND.trim()) {
        return null;
    }

    return (
        <Tooltip
            variant="beige"
            placement="bottom-start"
            content={
                <>
                    MVP
                    <br />
                    b: {shortSha(COMMIT_BACKEND)}
                    <br />
                    f: {shortSha(COMMIT_FRONTEND)}
                </>
            }
        >
            <button
                type="button"
                className="commit relative cursor-pointer appearance-none border-0 bg-transparent p-0"
                aria-label="MVP version"
            >
                <CommitIcon
                    nameOfClass="block h-24 w-24 fill-none opacity-40 transition-opacity hover:opacity-70"
                />
            </button>
        </Tooltip>
    );
};

export default CommitInfo;
